import React, { useMemo } from 'react';

import { AttentionCircleFilledIcon, CheckCircleFilledIcon, CrossCircleFilledIcon } from '@vlabs/icons';
import { Tag } from '@vlabs/uikit';
import classNames from 'classnames';

import st from './CheckTag.module.sass';

export type TResultStatus = 0 | 1 | 2;

interface CheckTagProps {
  kind: TResultStatus;
  value: string;
  toggle?: React.ReactNode;
}

const tagIconMap: Record<TResultStatus, React.ReactNode> = {
  0: <CrossCircleFilledIcon />,
  1: <CheckCircleFilledIcon />,
  2: <AttentionCircleFilledIcon />,
};
const tagKindMap: Record<TResultStatus, string> = {
  0: 'negative',
  1: 'positive',
  2: 'attention',
};

function CheckTag({
  kind,
  value,
  toggle = undefined,
}: CheckTagProps): React.JSX.Element {
  const $value = useMemo(() => {
    if (toggle) {
      return (
        <React.Fragment>
          {value}
          {toggle}
        </React.Fragment>
      );
    }

    return value;
  }, [toggle, value]);

  return (
    <Tag
      className={classNames(st.CheckTag, {
        [st.CheckTag__withToggle as string]: !!toggle,
      })}
      icon={tagIconMap[kind]}
      kind={tagKindMap[kind]}
      shape="square"
      size="large"
      value={$value}
    />
  );
}

export { CheckTag };
